import React, { useState, useEffect } from 'react';
import { MessageSquare, Mail, Phone } from 'lucide-react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';

export const ContactMessagesView = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Contact Messages</h2>
          <p className="text-gray-600">View customer inquiries and messages</p>
        </div>
        <div className="flex items-center gap-2">
          <MessageSquare className="w-5 h-5 text-gray-600" />
          <span className="text-2xl font-bold text-gray-900">{messages.length}</span>
        </div>
      </div>

      {isLoading ? (
        <p className="text-center text-gray-600 py-8">Loading messages...</p>
      ) : messages.length === 0 ? (
        <div className="text-center py-12">
          <MessageSquare className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-600">No messages yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {messages.map((message, index) => (
            <div
              key={index}
              className="border-2 border-gray-200 rounded-lg p-4"
            >
              {/* Message details */}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};